import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImageLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 28.395 28.394",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Bilde_til_venstre",
		"data-name": "Bilde til venstre",
		transform: "translate(-544.106 -1967.852)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "format_image_left_FILL0_wght300_GRAD0_opsz48",
			d: "M130,254.4v-1.841H158.4V254.4Zm0-6.35V232.335h15.711v15.711Zm0-20.2V226H158.4v1.841Zm1.841,18.363h12.029V234.176H131.842Zm18.223,1.544v-1.841H158.4v1.841h-8.331Zm0-6.631v-1.841H158.4v1.841h-8.331Zm0-6.646v-1.841H158.4v1.841h-8.331Z",
			transform: "translate(414.105 1741.851)"
		}), /* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_650",
			"data-name": "Rectangle 650",
			width: 14,
			height: 14,
			transform: "translate(545.5 1974.853)"
		})]
	})
});
export default SvgImageLeft;
